// Reorder Console - route component for /dashboard/reorder-console (unit U8; DESIGN §6.1, §6.2).
//   <RcErrorBoundary><RcProvider><RcPage/></RcProvider></RcErrorBoundary>
// The provider + page live in a lazily loaded chunk (reorder-console/shell/RcRoot.js), so the console's code is
// downloaded only by the people who open it; the skeleton shows while it loads. All page state is in the query string
// (lane, q, vm, cat, b, f, c, hide, sort, n, dg, cw, sz, po, dec - see reorder-console/state/urlState.js).
import React, { Suspense, lazy } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import RcErrorBoundary from './reorder-console/RcErrorBoundary';
import RcPageSkeleton from './reorder-console/shell/RcSkeleton';
import { TOOL_COLORS } from '../constants/colors';

const RcRoot = lazy(() => import('./reorder-console/shell/RcRoot'));

// The console's MUI "primary" parts (contained buttons, switches, focused fields, progress) in the Analytics teal, the
// way the other Analytics pages colour their controls (SalesDashboard.js); the rest keeps the user's theme. Meaning
// colours never come from palette.primary (reorder-console/tokens.js), so they are unaffected.
const analyticsPrimary = (outer) => ({
  ...outer,
  palette: {
    ...outer.palette,
    primary: outer.palette.augmentColor({
      color: { main: TOOL_COLORS.REPORTS.primary, dark: TOOL_COLORS.REPORTS.hover, contrastText: '#ffffff' },
      name: 'primary',
    }),
  },
});

export default function ReorderConsole() {
  return (
    <ThemeProvider theme={analyticsPrimary}>
      <RcErrorBoundary label="Reorder Console">
        <Suspense fallback={<RcPageSkeleton />}>
          <RcRoot />
        </Suspense>
      </RcErrorBoundary>
    </ThemeProvider>
  );
}
